<template>
  <lay-layer  v-model="show" :title="''" :closeBtn="false" :area="width + 'px'" :offset="['0px', '0px']" zIndex="999999" :isOutAnim="false" anim="-1">
    <div id="bg" >
      <img src="../assets/img/login_bg.png"  class="img">
      <img src="../assets/img/background.svg"  class="img" >
      <div style="position: fixed; left: 25px;top:17px;z-index: 1;height: 40px;line-height: 40px;color: #FFF;font-size: 23px;letter-spacing: 2px;">
      </div>
      <div  :style="{'top': '150px'}" style="position: fixed;width: 100%;z-index: 999;">
        <div style="margin: 0 auto;height: 500px;max-width: 800px;background: transparent;">
          <lay-row >
            <lay-col md="12" sm="12" xs="0" v-show="width > 768">
              <img  src="../assets/img/login_bg_left.png" style="height:500px;width: auto"/>
            </lay-col>
            <lay-col md="12" sm="12" xs="18" xs-offset="3">
              <div style="height: 500px;background: #FFF;" :style="{'border-radius': width > 768 ? '0 10px 10px 0' : '10px'}">
                <div style="padding: 70px 20px 0">
                  <lay-space direction="vertical" fill wrap :size="['35px', '0px']">
                    <h3 style="text-align: center;letter-spacing: 2px; font-size: 20px;color: #666;padding: 10px;font-weight: bold">智能电力运维平台</h3>
                    <lay-input @keyup.enter="login" suffix-icon="layui-icon-username" v-model="info.username" placeholder="请输入用户名"  :allow-clear="true" autofocus :maxlength="10">
                      <template #prepend>用户名</template>
                    </lay-input>
                    <lay-input @keyup.enter="login" suffix-icon="layui-icon-password" v-model="info.password" placeholder="请输入密码"  :allow-clear="true" :password="true" type="password" :maxlength="20">
                      <template #prepend>密 <span style="color: transparent">占</span> 码</template>
                    </lay-input>
                    <lay-button border="blue" fluid="true" :loading="loading" loadingIcon="layui-icon-loading" @click="login">登录</lay-button>
                  </lay-space>
                </div>
              </div>
            </lay-col>
          </lay-row>

        </div>
      </div>
    </div>
  </lay-layer>
</template>

<script setup>
import {useSize} from "@/assets/js/size";
import { onMounted, ref, defineEmits} from "vue";
import {layer} from "@layui/layui-vue";
import axios from "axios";
const emits = defineEmits(['onLogin']);
const {width} = useSize()
const show = ref(false)
const loading = ref(false);
const info = ref({
  username: '',
  password: ''
})
onMounted(() => {
  show.value = true
})
const msg = (info) =>  layer.msg(info, { icon : 3, time: 1000, zIndex: 9999999999})

const login = () => {
  if (loading.value){
    msg("登录中，请稍后。")
    return;
  }
  const {username, password} = info.value;
  if (!username || !password){
    msg("用户名或密码为空")
    return
  }
  loading.value = true

  let postData = {
    username,
    password
  }
  let retInfo = {
    success: false,
  }
  axios.post('/login', postData)
      .then(function (response) {
        if (response.data.code == 0){
          retInfo.success = true;
          retInfo.access_token = response.data.data;
        }

      })
      .catch(function () {
      }).finally(() => {
        msg(retInfo.success ? "登录成功" : "登录失败")
        setTimeout(() => {
          loading.value = false;
          emits('onLogin', retInfo)
        }, 300)
  });
}



</script>
<style scoped>
.img{
  position: fixed;
  left: 0;
  top:0;
  width: 100%;
  height: 100%;
}
</style>